<template>
  <div class="enroll-exam-write-student-pass-line" v-loading="loading" element-loading-text="数据加载中，请稍等...">
    <el-empty description="当前招生批次下还未设置笔试科目" v-if="!loading && examSubjectList.length<=0 && !error"></el-empty>
    <div v-else-if="!loading && examSubjectList.length>0 && !error" class="content">
      <el-form ref="enroll-exam-write-student-pass-line-form" label-width="auto" size="mini">
        <el-form-item :label="temp.examSubjectName" v-for="temp in examSubjectList"
                      :key="temp.examSubjectId">
          <div>
            <span>
               &nbsp;&nbsp;&nbsp;>=&nbsp;&nbsp;&nbsp;
            </span>
            <el-input v-model="temp.passScore" type="number" class="inp" min="0"></el-input>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn" v-if="!loading && examSubjectList.length>0 && !error">
      <el-button size="mini" @click="hidePopover">取消</el-button>
      <el-button type="primary" @click="savePassLine" size="mini" :loading="submitLoading">确定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnrollExamWriteStudentPassLine',
  props: ['visible'],
  data () {
    return {
      examSubjectList: [],
      loading: false,
      error: false,
      submitLoading: false
    }
  },
  created () {
    console.log(this)
    this.queryPassLine()
  },
  watch: {
    visible (newValue) {
      if (newValue) {
        this.queryPassLine()
      } else {
        this.error = false
        this.examSubjectList = []
      }
    }
  },
  methods: {
    hidePopover () {
      this.$emit('hidePopover')
    },
    hidePopoverAndRefresh () {
      this.$emit('hidePopoverAndRefresh')
    },
    queryPassLine () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/exam/write/student/query/pass/line',
        method: 'post',
        data: this.$qs.stringify({
          studentType: this.$attrs['extra-params'].studentType
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.examSubjectList = response.data['examSubjectList']
              this.error = false
              break
            }
            default: {
              this.$message.error(response.data['message'] || '查询失败')
              this.error = true
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    savePassLine () {
      for (const temp of this.examSubjectList) {
        if (!temp.passScore && temp.passScore !== 0) {
          this.$message.warning(`请填写科目${temp.examSubjectName}的分数线`)
          const r = /^([1-9]?\d+(\.\d{1,2})?)$/
          if (!r.test(this.score)) {
            this.$message.warning('请输入正确的分值，最大两位小数')
            return false
          }
          return false
        }
      }
      this.submitLoading = true
      this.$ajax({
        url: '/workspace/manager/enrolling/exam/write/student/save/pass/line',
        method: 'post',
        data: this.$qs.stringify({
          studentType: this.$attrs['extra-params'].studentType,
          subjectLines: JSON.stringify(this.examSubjectList)
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.hidePopoverAndRefresh()
              break
            }
            default: {
              this.$message.error(response.data['message'] || '修改失败')
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.submitLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.enroll-exam-write-student-pass-line {
  padding: 20px;
  min-height: 200px;
  font-size: 12px;
  .content{
    display: flex;
    justify-content: center;
    .inp{
      display: inline-block;
      width: 80px;
    }
  }
  .btn{
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }
}
</style>
